import { render, staticRenderFns } from "./ProformCategoryHead.vue?vue&type=template&id=10cee57c"
import script from "./ProformCategoryHead.vue?vue&type=script&lang=js"
export * from "./ProformCategoryHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports